import RestDataSource from './restdatasource';
import { Global_var } from '../global/global_var';
import { LoginService } from './login.service';

export const commonService = {
    fetchInstitute,
    fetchLookingFor,
    fetchPurpose,
};

function fetchInstitute(fn, fnError) {
  var url = Global_var.BASEURL + Global_var.URL_INSTITUTE_LIST;

  return new RestDataSource(url, fnError).GetData(res => {
    if (res != null) {
      if (res.headers["jtitoken"] != null) {
        localStorage.setItem("jti-token", res.headers.jtitoken);
      }
      fn(res.data);
    }
  });
}


function fetchLookingFor(fn, fnError) {

  let cdtype = "codeTypeId=10353";
  var url = Global_var.BASEURL + Global_var.URL_GETLOOKUP_BY_CD_TYPE_ID;
  LoginService.TokenUser(res => {
    localStorage.setItem("jwt-token", res.responseObject);
    return new RestDataSource(url, fnError).GetOneByParam(cdtype,res => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        fn(res.data);
      }
    });
  });
}

function fetchPurpose(fn, fnError) {
  let purposetype = "codeTypeId=10352";
  var url = Global_var.BASEURL + Global_var.URL_GETLOOKUP_BY_CD_TYPE_ID;
  return new RestDataSource(url, fnError).GetOneByParam(purposetype,res => {
    if (res != null) {
      if (res.headers["jtitoken"] != null) {
        localStorage.setItem("jti-token", res.headers.jtitoken);
      }
      fn(res.data);
    }
  });
}

